import React, { useState, useReducer, useEffect } from "react"
import {
  Modal,
  Button,
  Row,
  Col,
  Form,
  Select,
  Radio,
  Checkbox,
  Input,
  InputNumber,
  Spin,
  Alert,
  Space,
  Typography,
  Divider,
  message,
} from "antd"
import { CloseOutlined, SaveOutlined } from "@ant-design/icons"
import NumeralButton from "components/Common/NumeralButton"
import { serializeQuery } from "helpers/service_helper"
import "./table.scss"

const { Text } = Typography

export const ProjectRequired = ({ rowData, mainProps }) => {
  const { onGetProjectFiles, lstGasProjectFiles } = mainProps




  const [sumTotalCount, dispatchSumTotalCount] = useReducer((state, action) => {
    return Number((state + action).toFixed(1))
  }, rowData.gasProjectDetail.totalCount)

  const [sumTotalUsage, dispatchSumTotalUsage] = useReducer((state, action) => {
    return Number((state + action).toFixed(1))
  }, rowData.gasProjectDetail.totalUsage)

  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      id: rowData.gasProjectDetail.id,
      consent: rowData.gasProjectDetail.consent,
      pipeSize: rowData.gasProjectDetail.pipeSize
        ? rowData.gasProjectDetail.pipeSize
        : 1,
      collectorSize: rowData.gasProjectDetail.collectorSize
        ? rowData.gasProjectDetail.collectorSize
        : 0,
      locationGasMeter: rowData.gasProjectDetail.locationGasMeter
        ? rowData.gasProjectDetail.locationGasMeter
        : "حیاط",
      desLocationGasMeter: rowData.gasProjectDetail.desLocationGasMeter,
      needSubCutter: rowData.gasProjectDetail.needSubCutter,
      windowsSealingStatus: rowData.gasProjectDetail.windowsSealingStatus
        ? rowData.gasProjectDetail.windowsSealingStatus
        : "هوابند",
      desWindowsSealing: rowData.gasProjectDetail.desWindowsSealing,
      gOvnCount: rowData.gasProjectDetail.gOvnCount,
      gOvnUsage: rowData.gasProjectDetail.gOvnUsage,
      gComCount: rowData.gasProjectDetail.gComCount,
      gComUsage: rowData.gasProjectDetail.gComUsage,
      hitterUsage: rowData.gasProjectDetail.hitterUsage,
      hitterCount: rowData.gasProjectDetail.hitterCount,
      whWaCount: rowData.gasProjectDetail.whWaCount,
      whWaUsage: rowData.gasProjectDetail.whWaUsage,
      whWaFanCount: rowData.gasProjectDetail.whWaFanCount,
      whWaFanUsage: rowData.gasProjectDetail.whWaFanUsage,
      whFlCount: rowData.gasProjectDetail.whFlCount,
      whFlUsage: rowData.gasProjectDetail.whFlUsage,
      pWaCount: rowData.gasProjectDetail.pWaCount,
      pWaUsage: rowData.gasProjectDetail.pWaUsage,
      pFlCount: rowData.gasProjectDetail.pFlCount,
      pFlUsage: rowData.gasProjectDetail.pFlUsage,
      pFaCount: rowData.gasProjectDetail.pFaCount,
      pFaUsage: rowData.gasProjectDetail.pFaUsage,
      pFaFactor:
        Number(
          (
            rowData.gasProjectDetail.pFaUsage /
            rowData.gasProjectDetail.pFaCount
          ).toFixed(1)
        ) || 2.5,
      burnerCount: rowData.gasProjectDetail.burnerCount,
      burnerUsage: rowData.gasProjectDetail.burnerUsage,
      burnerFactor:
        Number(
          (
            rowData.gasProjectDetail.burnerUsage /
            rowData.gasProjectDetail.burnerCount
          ).toFixed(1)
        ) || 0,
      rComCount: rowData.gasProjectDetail.rComCount,
      rComUsage: rowData.gasProjectDetail.rComUsage,
      rNormCount: rowData.gasProjectDetail.rNormCount,
      totalCount: rowData.gasProjectDetail.totalCount,
      totalUsage: rowData.gasProjectDetail.totalUsage,
      rNormUsage: rowData.gasProjectDetail.rNormUsage,
      autoGasCutOff: rowData.gasProjectDetail.autoGasCutOff,
      gasLeakWarning: rowData.gasProjectDetail.gasLeakWarning,
      gasCutOffExt: rowData.gasProjectDetail.gasCutOffExt,
      whpLocation: rowData.gasProjectDetail.whpLocation,
      rLocation: rowData.gasProjectDetail.rLocation,
      chDiameter: rowData.gasProjectDetail.chDiameter,
      veDimension: rowData.gasProjectDetail.veDimension,
      groupTypeEnum: rowData.gasProjectDetail.groupTypeEnum,
      geoTypeEnum: rowData.gasProjectDetail.geoTypeEnum,
      unitTypeEnum: rowData.gasProjectDetail.unitTypeEnum,
      description: rowData.gasProjectDetail.description,
    }
  )
  const [open, setOpen] = useState(false)
  const handleInput = evt => {
    const name = evt.target.name

    if (name.indexOf("Count") !== -1) dispatchSumTotalCount(-formInput[name])
    if (name.indexOf("Count") !== -1) dispatchSumTotalCount(+evt.target.value)

    if (name.indexOf("Usage") !== -1) dispatchSumTotalUsage(-formInput[name])
    if (name.indexOf("Usage") !== -1) dispatchSumTotalUsage(+evt.target.value)

    let newValue = evt.target.value
    if (newValue == "on") newValue = evt.target.checked

    if (evt.target.attributes?.type?.value === "text") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }
    if (evt.target.attributes?.type?.value === "number") newValue = +newValue
    if (evt.target.attributes?.type?.value === "radio") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }


    if(name == "geoTypeEnum"){
      if(+newValue == 0){
        message.error("جهت جغرافیایی را مشخص کنید.")
      }
    }
    if(name == "groupTypeEnum"){
      if(+newValue == 0){
        message.error("جهت جغرافیایی را مشخص کنید.")
      }
    }

    if (name === "gComCount") {
      const usageValue = Math.round(0.7 * newValue * 100) / 100
      setFormInput({ ["gComUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["gComUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "hitterCount") {
      const usageValue = Math.round(0.6 * newValue * 100) / 100
      setFormInput({ ["hitterUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["hitterUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "rNormCount") {
      const usageValue = Math.round(0.3 * newValue * 100) / 100
      setFormInput({ ["rNormUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["rNormUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "whFlCount") {
      const usageValue = Math.round(1.5 * newValue * 100) / 100
      setFormInput({ ["whFlUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["whFlUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "whWaCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["whWaUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["whWaUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "whWaFanCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["whWaFanUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["whWaFanUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "gOvnCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["gOvnUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["gOvnUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "rComCount") {
      const usageValue = Math.round(2.5 * newValue * 100) / 100
      setFormInput({ ["rComUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["rComUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "pFaCount") {
      const usageValue =
        Math.round(+formInput["pFaFactor"] * newValue * 100) / 100
      setFormInput({ ["pFaUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["pFaUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "pFaFactor") {
      const usageValue =
        Math.round(+formInput["pFaCount"] * newValue * 100) / 100
      setFormInput({ ["pFaUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["pFaUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "burnerCount") {
      const usageValue =
        Math.round(+formInput["burnerFactor"] * newValue * 100) / 100
      setFormInput({ ["burnerUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["burnerUsage"])
      dispatchSumTotalUsage(usageValue)
    }
    if (name === "burnerFactor") {
      const usageValue =
        Math.round(+formInput["burnerCount"] * newValue * 100) / 100
      setFormInput({ ["burnerUsage"]: usageValue })
      dispatchSumTotalUsage(-formInput["burnerUsage"])
      dispatchSumTotalUsage(usageValue)
    }

    setFormInput({ [name]: newValue })
  }
  const date1 = new Date(rowData.julianRegisterDate);
  const date2 = new Date("2024-08-24");
  
  const checkDate = date1 > date2
  
  useEffect(async() => {
    if(open){
    await onGetProjectFiles(rowData.id)
    
    }
  }, [open])
  const handleSubmitForm = async event => {
    const { onUpdateGasProjectDetailsNew } = mainProps
    event.preventDefault()
    const data = new FormData(event.currentTarget)
    data.forEach((value, name) => {
      if (value == "on") {
        value = true
      }
      setFormInput({ [name]: value })
    })
    let mapToSave = {
      ...formInput,
      totalCount: sumTotalCount,
      totalUsage: sumTotalUsage,
      pipeSize: +formInput.pipeSize,
      collectorSize: +formInput.collectorSize,
      geoTypeEnum: +formInput.geoTypeEnum,
      groupTypeEnum: +formInput.groupTypeEnum,
      unitTypeEnum: +formInput.unitTypeEnum,
      consent: formInput.consent === "true" || formInput.consent === true,
      autoGasCutOff:
        formInput.autoGasCutOff === "true" || formInput.autoGasCutOff === true,
      gasCutOffExt:
        formInput.gasCutOffExt === "true" || formInput.gasCutOffExt === true,
      gasLeakWarning:
        formInput.gasLeakWarning === "true" ||
        formInput.gasLeakWarning === true,
      needSubCutter:
        formInput.needSubCutter === "true" || formInput.needSubCutter === true,
    }
    await onUpdateGasProjectDetailsNew({
      process: mapToSave,
      queryString: serializeQuery({ idFile: rowData.idFile }),
    })
  }
  return (
    <>
      <Button
        type="link"
        size="small"
        onClick={() => setOpen(true)}
        style={{ padding: "0 4px" }}
      >
        الزامات
      </Button>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        width={820}
        style={{ top: 50 }}
        footer={null}
        closeIcon={<CloseOutlined />}
        title={
          <Space direction="vertical" size={4} style={{ width: "100%" }}>
            <Text>
              مالک: <Text strong>{rowData.landLordName}</Text> — پرونده:{" "}
              <Text strong>{rowData.fileNumber}</Text> — تعداد واحد:{" "}
              <Text strong>{rowData.unitNumber}</Text> — طبقه:{" "}
              <Text strong>
                {rowData.floorNumber === 0
                  ? rowData.unitNumber > 1
                    ? "چند واحدی"
                    : "همکف"
                  : rowData.floorNumber}
              </Text>
            </Text>
            {lstGasProjectFiles.findIndex(x => x.fileTypeEnum === 11) === -1 &&
              checkDate && (
                <Alert
                  type="error"
                  message="نقشه طراحی را ابتدا آپلود کنید"
                  showIcon
                  style={{ borderRadius: 8 }}
                />
              )}
          </Space>
        }
      >
        <form onSubmit={handleSubmitForm}>
          <Row gutter={[12, 12]} style={{ marginTop: 8 }}>
            {/* گروه بندی ساختمان */}
            <Col xs={24} sm={8}>
              <Form.Item label="گروه بندی ساختمان" style={{ margin: 0 }}>
                <Select
                  name="groupTypeEnum"
                  value={formInput.groupTypeEnum}
                  onChange={val =>
                    handleInput({ target: { name: "groupTypeEnum", value: val, attributes: { type: { value: "number" } } } })
                  }
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Select.Option value={0}>نامشخص</Select.Option>
                  <Select.Option value={1}>مسکونی</Select.Option>
                  <Select.Option value={2}>عمومی</Select.Option>
                  <Select.Option value={3}>خاص</Select.Option>
                  <Select.Option value={4}>تلفیقی</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            {/* نوع آپارتمان */}
            {(+formInput.groupTypeEnum === 1 ||
              +formInput.groupTypeEnum === 2) && (
              <Col xs={24} sm={8}>
                <Form.Item label="نوع آپارتمان در گروه بندی" style={{ margin: 0 }}>
                  <Select
                    name="unitTypeEnum"
                    value={formInput.unitTypeEnum}
                    onChange={val =>
                      handleInput({ target: { name: "unitTypeEnum", value: val, attributes: { type: { value: "number" } } } })
                    }
                    size="small"
                    style={{ width: "100%" }}
                  >
                    <Select.Option value={0}>نامشخص</Select.Option>
                    <Select.Option value={1}>آپارتمان ۱ واحدی</Select.Option>
                    <Select.Option value={2}>آپارتمان ۲ تا ۱۰ واحدی</Select.Option>
                    <Select.Option value={3}>آپارتمان ۱۱ تا ۳۰ واحدی</Select.Option>
                    <Select.Option value={4}>آپارتمان ۳۱ واحدی به بالا</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            )}

            {/* رضایت نامه */}
            <Col xs={24} sm={+formInput.groupTypeEnum === 1 || +formInput.groupTypeEnum === 2 ? 8 : 16}>
              <Form.Item label="نیاز به رضایت نامه محضری" style={{ margin: 0 }}>
                <Radio.Group
                  name="consent"
                  value={formInput.consent}
                  onChange={handleInput}
                >
                  <Radio value={true}>بلی</Radio>
                  <Radio value={false}>خیر</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            {/* سایز لوله */}
            <Col xs={24} sm={8}>
              <Form.Item label="سایز لوله اصلی (اینچ)" style={{ margin: 0 }}>
                <Select
                  name="pipeSize"
                  value={formInput.pipeSize}
                  onChange={val =>
                    handleInput({ target: { name: "pipeSize", value: val, attributes: { type: { value: "number" } } } })
                  }
                  size="small"
                  style={{ width: "100%" }}
                >
                  {[1, 1.25, 1.5, 2, 2.5, 3, 4].map(v => (
                    <Select.Option key={v} value={v}>
                      {v === 1.25 ? "1-1/4" : v === 1.5 ? "1-1/2" : v === 2.5 ? "2-1/2" : v}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* سایز کلکتور */}
            <Col xs={24} sm={8}>
              <Form.Item label="سایز کلکتور (اینچ)" style={{ margin: 0 }}>
                <Select
                  name="collectorSize"
                  value={formInput.collectorSize}
                  onChange={val =>
                    handleInput({ target: { name: "collectorSize", value: val, attributes: { type: { value: "number" } } } })
                  }
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Select.Option value={0}>ندارد</Select.Option>
                  {[1.25, 1.5, 2, 2.5, 3, 4].map(v => (
                    <Select.Option key={v} value={v}>
                      {v === 1.25 ? "1-1/4" : v === 1.5 ? "1-1/2" : v === 2.5 ? "2-1/2" : v}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* جهت جغرافیایی */}
            <Col xs={24} sm={8}>
              <Form.Item label="جهت جغرافیایی ملک" style={{ margin: 0 }}>
                <Select
                  name="geoTypeEnum"
                  value={formInput.geoTypeEnum}
                  onChange={val =>
                    handleInput({ target: { name: "geoTypeEnum", value: val, attributes: { type: { value: "number" } } } })
                  }
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Select.Option value={0}>نامشخص</Select.Option>
                  <Select.Option value={1}>شمالی</Select.Option>
                  <Select.Option value={2}>جنوبی</Select.Option>
                  <Select.Option value={3}>شرقی</Select.Option>
                  <Select.Option value={4}>غربی</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            {/* محل کنتور */}
            <Col xs={24}>
              <Form.Item label="محل اجرای کنتور — مطابق محل تعیین شده بر روی پلان" style={{ margin: 0 }}>
                <Radio.Group
                  name="locationGasMeter"
                  value={formInput.locationGasMeter}
                  onChange={handleInput}
                >
                  <Space wrap>
                    {["حیاط", "پارکینگ", "پاگرد", "بیرون ملک", "داخل مغازه", "راهرو"].map(loc => (
                      <Radio key={loc} value={loc}>{loc}</Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>

            {/* شیر قطع کن فرعی */}
            <Col xs={24} sm={12}>
              <Form.Item label="شیر قطع کن فرعی مورد نیاز است؟" style={{ margin: 0 }}>
                <Radio.Group
                  name="needSubCutter"
                  value={formInput.needSubCutter}
                  onChange={handleInput}
                >
                  <Radio value={true}>بلی</Radio>
                  <Radio value={false}>خیر</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            {/* وضعیت درزبندی */}
            <Col xs={24} sm={12}>
              <Form.Item label="وضعیت درزبندی پنجره ها" style={{ margin: 0 }}>
                <Radio.Group
                  name="windowsSealingStatus"
                  value={formInput.windowsSealingStatus}
                  onChange={handleInput}
                >
                  <Radio value="هوابند">هوابند</Radio>
                  <Radio value="درزدار">درزدار</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            {/* توضیحات درزبندی */}
            <Col xs={24}>
              <Form.Item label="توضیحات تعداد و محل نصب دریچه های تامین هوا" style={{ margin: 0 }}>
                <Input
                  name="desWindowsSealing"
                  value={formInput.desWindowsSealing ?? ""}
                  size="small"
                  onChange={handleInput}
                  required
                  style={{ textAlign: "center" }}
                />
              </Form.Item>
            </Col>

            {/* جدول مصرف کننده ها */}
            <Col xs={24}>
              <Divider style={{ margin: "8px 0" }}>
                <Text type="secondary" style={{ fontSize: 12 }}>مصرف کننده‌ها</Text>
              </Divider>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: 13,
                  direction: "rtl",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f0f0f0" }}>
                    <th style={thStyle}>مصرف کننده</th>
                    <th style={thStyle}>تعداد</th>
                    <th style={thStyle}>مصرف</th>
                    <th style={thStyle}>جمع</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { label: "اجاق گاز GC", countKey: "gComCount", usageKey: "gComUsage", factor: "0.7" },
                    { label: "بخاری H", countKey: "hitterCount", usageKey: "hitterUsage", factor: "0.6" },
                    { label: "کباب پز RC", countKey: "rNormCount", usageKey: "rNormUsage", factor: "0.3" },
                    { label: "آبگرمکن زمینی WH", countKey: "whFlCount", usageKey: "whFlUsage", factor: "1.5" },
                    { label: "آبگرمکن دیواری WWH", countKey: "whWaCount", usageKey: "whWaUsage", factor: "2.5" },
                    { label: "آبگرمکن دیواری فن دار WWHF", countKey: "whWaFanCount", usageKey: "whWaFanUsage", factor: "2.5" },
                    { label: "اجاق گاز تجاری GCT", countKey: "gOvnCount", usageKey: "gOvnUsage", factor: "2.5" },
                    { label: "پلوپز تجاری RCT", countKey: "rComCount", usageKey: "rComUsage", factor: "2.5" },
                  ].map(row => (
                    <tr key={row.countKey} style={trStyle}>
                      <td style={tdStyle}>{row.label}</td>
                      <td style={tdStyle}>
                        <NumeralButton
                          lblName=""
                          initValue={formInput[row.countKey]}
                          objName={row.countKey}
                          changeValue={1}
                          changeValueDecimal={0}
                          callBack={handleInput}
                        />
                      </td>
                      <td style={tdStyle}>{row.factor}</td>
                      <td style={tdStyle}>{formInput[row.usageKey]}</td>
                    </tr>
                  ))}
                  {/* پکیج */}
                  <tr style={trStyle}>
                    <td style={tdStyle}>پکیج P</td>
                    <td style={tdStyle}>
                      <NumeralButton lblName="" initValue={formInput.pFaCount} objName="pFaCount" changeValue={1} changeValueDecimal={0} callBack={handleInput} />
                    </td>
                    <td style={tdStyle}>
                      <NumeralButton lblName="" initValue={formInput.pFaFactor} objName="pFaFactor" changeValue={1} changeValueDecimal={0.1} callBack={handleInput} />
                    </td>
                    <td style={tdStyle}>{formInput.pFaUsage}</td>
                  </tr>
                  {/* مشعل */}
                  <tr style={trStyle}>
                    <td style={tdStyle}>مشعل B</td>
                    <td style={tdStyle}>
                      <NumeralButton lblName="" initValue={formInput.burnerCount} objName="burnerCount" changeValue={1} changeValueDecimal={0} callBack={handleInput} />
                    </td>
                    <td style={tdStyle}>
                      <NumeralButton lblName="" initValue={formInput.burnerFactor} objName="burnerFactor" changeValue={1} changeValueDecimal={0.1} callBack={handleInput} />
                    </td>
                    <td style={tdStyle}>{formInput.burnerUsage}</td>
                  </tr>
                  {/* جمع کل */}
                  <tr style={{ backgroundColor: "#e6f7ff" }}>
                    <td style={{ ...tdStyle, fontWeight: 600 }} colSpan={2}>جمع کل</td>
                    <td style={{ ...tdStyle, color: "#1890ff", fontWeight: 600 }}>مصرف: {sumTotalUsage}</td>
                    <td style={{ ...tdStyle, color: "#1890ff", fontWeight: 600 }}>تعداد: {sumTotalCount}</td>
                  </tr>
                </tbody>
              </table>
            </Col>

            {/* الزامات ایمنی */}
            <Col xs={24}>
              <Form.Item label="الزامات نصب تجهیزات ایمنی" style={{ margin: 0 }}>
                <Space wrap>
                  <Checkbox
                    name="gasLeakWarning"
                    checked={formInput.gasLeakWarning ?? false}
                    onChange={handleInput}
                  >
                    آشکارساز گاز طبیعی
                  </Checkbox>
                  <Checkbox
                    name="gasCutOffExt"
                    checked={formInput.gasCutOffExt ?? false}
                    onChange={handleInput}
                  >
                    آشکارساز مونوکسید کربن
                  </Checkbox>
                  <Checkbox
                    name="autoGasCutOff"
                    checked={formInput.autoGasCutOff ?? false}
                    onChange={handleInput}
                  >
                    شیر خودکار قطع گاز در زلزله
                  </Checkbox>
                </Space>
              </Form.Item>
            </Col>

            {/* تعداد/قطر دودکش */}
            <Col xs={24} sm={12}>
              <Form.Item label="تعداد/قطر دودکش" style={{ margin: 0 }}>
                <Input
                  name="chDiameter"
                  value={formInput.chDiameter ?? ""}
                  size="small"
                  onChange={handleInput}
                  required
                  style={{ textAlign: "center" }}
                />
              </Form.Item>
            </Col>

            {/* تعداد/ظرفیت اگزاست */}
            <Col xs={24} sm={12}>
              <Form.Item label="تعداد/ظرفیت اگزاست" style={{ margin: 0 }}>
                <Input
                  name="veDimension"
                  value={formInput.veDimension ?? ""}
                  size="small"
                  onChange={handleInput}
                  required
                  style={{ textAlign: "center" }}
                />
              </Form.Item>
            </Col>

            {/* توضیحات */}
            <Col xs={24}>
              <Form.Item label="توضیحات" style={{ margin: 0 }}>
                <Input.TextArea
                  name="description"
                  value={formInput.description ?? ""}
                  rows={4}
                  onChange={handleInput}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Footer */}
          <Row justify="end" style={{ marginTop: 16 }}>
            <Space>
              <Button onClick={() => setOpen(false)}>بازگشت</Button>
              {mainProps.loading ? (
                <Spin />
              ) : (
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  style={{ borderRadius: 8 }}
                >
                  ذخیره
                </Button>
              )}
            </Space>
          </Row>
        </form>
      </Modal>
    </>
  )
}

const thStyle = {
  border: "1px solid #d9d9d9",
  padding: "6px 10px",
  textAlign: "center",
  fontWeight: 600,
}
const tdStyle = {
  border: "1px solid #f0f0f0",
  padding: "4px 8px",
  textAlign: "center",
}
const trStyle = {
  borderBottom: "1px solid #f0f0f0",
}
